import {Component, EventEmitter, OnDestroy, OnInit} from '@angular/core';
import {CardHolder, CardModel, IPlatformToolCard, MagicLinkModel} from '@shared/models/platform-tool-models';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {PlatformQuery, PlatformQueryResponse} from '@shared/models/platform-query/platform-query';
import {Subject, take, takeUntil} from 'rxjs';
import {ViewEncapsulation} from '@angular/core';
import {Guid} from 'guid-typescript';
import {FileModel} from '@shared/models/file-model';
import {StringUtility} from '@shared/utility/string-utility';
import {FileManagementService} from '@core/services/file-management.service';
import {PlatformCommand} from '@shared/commands/command-base';
import {Api} from '@shared/constants/common-field.constants';
import {CommandService} from '@core/services/command.service';
import {FuseSplashScreenService} from '@barebone-fuse/@fuse/services/splash-screen.service';
import {PlatformQueryService} from '@core/services/platform-query.service';

@Component({
    standalone: false,
    selector: 'app-platform-tool-cbc-date-filed-card',
  templateUrl: './platform-tool-cbc-date-filed-card.component.html',
  styleUrls: ['./platform-tool-cbc-date-filed-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PlatformToolCbcDateFiledCardComponent implements OnInit, OnDestroy, IPlatformToolCard {
  handler: IPlatformToolHandler;
  magicLinkModel: MagicLinkModel;
  invalidateSubject: InvalidateSubject;
  cardHolder: CardHolder;
  card: CardModel;
  queryResponse: PlatformQueryResponse;

  navbars: any;
  selectedNavbar: any;


  //filing details
  filingTypes = [];
  selectedFilingType: any;


  filingstatuses = [];
  selectedFilingStatus: any;
  filingStatusColor = '';
  currentFilingStatus: any;


  currentFilingItem: any;
  relatedLinks = [];
  dueDate: any;
  dueDateFieldKey = '';
  fieldKey = '';
  fieldKeyModel = '';

  isNotApplicable = false;
  selectedFilingStatusTitle = '';
  dateFiled: Date;
  selectedTabIndex: number = 1;

  fileToUpload: File;
  acceptedFileTypes = '.xml, .txt, .csv, .xlsx, .pdf, .cht, .doc, .docx, .xls';
  private ngUnsubscribe = new Subject<void>();
  existingUploadFileModel: any;

  constructor(private fileManagementService: FileManagementService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private platformQueryService: PlatformQueryService,
              private commandService: CommandService) {
    this.navbars = [
      {
        name: 'Related Links',
        id: 'related-links'
      },
      {
        name: 'Filing Details',
        id: 'filing-details'
      }
    ];
    this.selectedNavbar = this.navbars[1];
    this.selectedTabIndex = 1;

    this.setInitialFilingTypesData();
    this.setFilingStatusData();
  }

  //#region initializations
  private setFilingStatusData() {
    this.filingstatuses = ['To Do', 'In Progress', 'Completed'];
  }

  private setInitialFilingTypesData() {
    this.filingTypes = ['CbC Notifications', 'CbC Reports', 'Master Files', 'Local Files'];
    //this.selectedFilingType = this.filingTypes[0];
    this.setAdditionalDataAndRecalculate();
  }

  ngOnInit(): void {
    this.subscribeToItemsChanges();
    this.subscribeToFieldSectionChanges();
  }

  private subscribeToFieldSectionChanges() {
    this.handler.metaData.fieldSectionInfoEmitter.pipe(takeUntil(this.ngUnsubscribe)).subscribe((fieldSectionData) => {
      if (fieldSectionData == null || fieldSectionData == undefined) {
        return;
      }
      this.handleFieldSectionChanged(fieldSectionData);
    });
  }

  private subscribeToItemsChanges() {
    if (this.isNullOrUndefined(this.handler.metaData.cbcFilingDateFiledEventEmitter)) {
      this.handler.metaData.cbcFilingDateFiledEventEmitter = new EventEmitter<any>(); // to listen clear event from left panel filter
    }
    this.handler.metaData.cbcFilingDateFiledEventEmitter.pipe(takeUntil(this.ngUnsubscribe)).subscribe(event => {
      this.InitializeData(event);
    });
  }

  //#endregion

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  onClickedNav(item) {
    this.selectedNavbar = item;
  }

  onSelectedNavBarChange() {
    this.selectedTabIndex = this.selectedTabIndex === 0 ? 1 : 0;
    this.selectedNavbar = this.navbars[this.selectedTabIndex];
  }

  onLoad() {

  }

  private handleFieldSectionChanged(fieldSectionData: any) {
    this.setSelectedFileType(fieldSectionData);
    this.setAdditionalDataAndRecalculate();
  }

  private setAdditionalDataAndRecalculate() {
    this.setFieldKeyAndDueDateFieldKey(this.selectedFilingType);
    this.recalculateData();
  }

  InitializeData(intializingData) {
    if (this.currentFilingItem && this.currentFilingItem.id === intializingData.datefileditem.id) {
      return;
    }
    this.fileToUpload = null;
    this.currentFilingItem = intializingData.datefileditem;
    this.getRelatedLinksAndInitializeData();
  }


  private getRelatedLinksAndInitializeData() {
    let query = this.getRelatedLinksQuery();
    this.fuseSplashScreenService.show();
    this.relatedLinks = [];
    this.platformQueryService.executeQuery(query).pipe(take(1)).subscribe(result => {
      if (result && result.fieldValues && result.fieldValues['Websites']) {
        this.relatedLinks = result.fieldValues['Websites'];
      }
      this.recalculateData();
      this.fuseSplashScreenService.hide();
    }, error => {
      this.recalculateData();
      this.fuseSplashScreenService.hide();
    });
  }

  private getRelatedLinksQuery() {
    let query = new PlatformQuery();
    query.name = 'GetCountrySpecificTaxWebsiteInformationQuery';
    query.api = Api.ITRCE;
    query.fieldValues['CountryName'] = this.currentFilingItem.cells?.Jurisdiction?.value?.name;
    query.fieldValues['Tag'] = 'CbC';
    return query;
  }

  recalculateData() {
    if (this.currentFilingItem == null || this.currentFilingItem == undefined) {
      return;
    }
    this.dueDate = this.currentFilingItem.cells[this.dueDateFieldKey];
    this.filingStatusColor = this.loadCalculatedStatusColor(this.currentFilingItem.cells[this.fieldKeyModel].value.CalculatedStatus);
    this.currentFilingStatus = this.currentFilingItem.cells[this.fieldKeyModel].value.Status;
    this.isNotApplicable = this.currentFilingItem.cells[this.fieldKeyModel].value.IsNotApplicable;
    this.lodeSelectedFilingStatus();
    this.setDateFiled();
    this.setDateFiledModel();
  }

  onFilingTypeChange($event) {
    console.log('asdasd');
    let value = $event.value;
    let index = this.filingTypes.findIndex(o => o.toLowerCase() == value.toLowerCase());
    this.selectedFilingType = this.filingTypes[index];
    this.setAdditionalDataAndRecalculate();
  }

  onFilingStatusChange($event) {
    this.selectedFilingStatus = $event.value;
  }

  onFileChange(event) {
  }


  setFieldKeyAndDueDateFieldKey(selectedFilingTypeValue) {
    switch (selectedFilingTypeValue) {
      case 'CbC Reports':
        this.dueDateFieldKey = 'TC-CbCReportDueDate';
        this.fieldKey = 'CbcReportDateFiled';
        this.fieldKeyModel = this.fieldKey + '_Model';
        break;
      case 'CbC Notifications':
        this.dueDateFieldKey = 'TC-CbCNotificationDueDate';
        this.fieldKey = 'NotificationDateFiled';
        this.fieldKeyModel = this.fieldKey + '_Model';
        break;
      case 'Master Files':
        this.dueDateFieldKey = 'TC-CbCMasterFileDueDate';
        this.fieldKey = 'MFDateFiled';
        this.fieldKeyModel = this.fieldKey + '_Model';
        break;
      case 'Local Files':
        this.dueDateFieldKey = 'TC-CbCLocalFileDueDate';
        this.fieldKey = 'LFDateFiled';
        this.fieldKeyModel = this.fieldKey + '_Model';
        break;
      default:
        break;
    }
  }


  setSelectedFileType(fieldSectionData: any) {
    let header = fieldSectionData.header.toLowerCase();
    let index = this.filingTypes.findIndex(o => o.toLowerCase() == header);
    if (index !== -1) {
      this.selectedFilingType = this.filingTypes[index];
    }
  }


  setDateFiled() {
    let dateFiledString = this.currentFilingItem.cells[this.fieldKeyModel].value.DateFiled;
    if (dateFiledString === '0001-01-01T00:00:00Z' || dateFiledString === '1/1/0001 12:00 AM') {
      this.dateFiled = new Date();
    } else {
      this.dateFiled = new Date(dateFiledString);
    }
  }

  setDateFiledModel() {
    if (this.currentFilingItem.cells[this.fieldKeyModel].value.FileModel) {
      this.existingUploadFileModel = this.currentFilingItem.cells[this.fieldKeyModel].value.FileModel;
    } else {
      this.existingUploadFileModel = null;
    }
  }

  loadCalculatedStatusColor(calculatedStatus) {
    let color = '';
    switch (calculatedStatus) {
      case 'Upcoming':
        color = 'up-coming';
        break;
      case 'Due Soon':
        color = 'due-soon';
        break;
      case 'In Progress':
        color = 'in-progress';
        break;
      case 'Completed':
        color = 'completed';
        break;
      case 'Over Due':
        color = 'over-due';
        break;
      case 'To Do':
        color = 'up-coming';
        break;
      default:
        break;
    }
    return color;
  }


  lodeSelectedFilingStatus() {
    switch (this.currentFilingStatus) {
      case 'Completed':
        this.selectedFilingStatus = this.filingstatuses[2];
        break;
      case 'In Progress':
        this.selectedFilingStatus = this.filingstatuses[1];
        break;
      default:
        this.selectedFilingStatus = this.filingstatuses[0];
        break;
    }
  }


  clearExistingUploadedFileModel() {
    this.existingUploadFileModel = null;
  }

  downloadExistingFile() {
    if (!this.existingUploadFileModel?.directoryEntryId) return;
    this.fuseSplashScreenService.show();
    this.fileManagementService.downloadClientFileWithId(this.existingUploadFileModel.directoryEntryId)
      .pipe(take(1))
      .subscribe(payload => {
        this.fuseSplashScreenService.hide();
        this.fileManagementService.openSaveFileWindow(payload, this.existingUploadFileModel.fileName);
      }, error => {
        this.fuseSplashScreenService.hide();
      });
  }

  filingDateChanged(event) {
    this.dateFiled = event.value;
  }


  private uploadFileAndSave(filingSaveCommand: PlatformCommand) {
    if (this.fileToUpload == null || this.fileToUpload == undefined) {
      filingSaveCommand.fieldValues['DirectoryEntryId'] = this.existingUploadFileModel?.directoryEntryId;
      this.postFilingSaveCommand(filingSaveCommand);
      return;
    }
    let uploadPath = `Root/${Guid.create().toString()}/Uploads`;
    let isClientFile = true;
    let fileNameWithoutExtension = StringUtility.getFileNameExcludingExtension(this.fileToUpload.name);
    const uploadedFileModel = FileModel.createClientFileModel(uploadPath, this.fileToUpload, fileNameWithoutExtension, isClientFile);
    this.fuseSplashScreenService.show();
    this.fileManagementService.uploadFile(this.fileToUpload, uploadedFileModel, true).pipe(take(1)).subscribe(res => {
      this.fuseSplashScreenService.hide();
      if (res) {
        filingSaveCommand.fieldValues['DirectoryEntryId'] = res;
        this.postFilingSaveCommand(filingSaveCommand);
      }
    }, error => {
      this.fuseSplashScreenService.hide();
      console.log('failed to upload the file');
    });
  }


  onSave() {
    let filingSaveCommand = new PlatformCommand('CbcFilingFiledDateStatusUpdateCommand', Api.DueDateTracker);
    filingSaveCommand.projectId = '[PROJECT_ID]';
    filingSaveCommand.fieldValues['CbcFilingItemId'] = this.currentFilingItem.id;
    filingSaveCommand.fieldValues['DateFiledKey'] = this.fieldKey;
    filingSaveCommand.fieldValues['DateFiledStatus'] = this.selectedFilingStatus;
    if (this.selectedFilingStatus == 'Completed') {
      filingSaveCommand.fieldValues['DateFiled'] = this.dateFiled.toDateString();
      this.uploadFileAndSave(filingSaveCommand);
    } else {
      this.postFilingSaveCommand(filingSaveCommand);
    }
  }

  postFilingSaveCommand(filingSaveCommand) {
    this.fuseSplashScreenService.show();
    this.commandService.executePlatformCommand(filingSaveCommand).pipe(take(1)).subscribe(result => {
      this.fileToUpload = null;
      if (result && result.fieldValues.hasOwnProperty('NewFileModel')) {
        this.existingUploadFileModel = result.fieldValues['NewFileModel'];
        this.currentFilingItem.cells[this.fieldKeyModel].value.FileModel = result.fieldValues['NewFileModel'];
      }
      if (result && result.fieldValues['DateFiled']) {
        this.currentFilingItem.cells[this.fieldKeyModel].value.DateFiled = result.fieldValues['DateFiled'];
      }
      this.fuseSplashScreenService.hide();
      this.invalidateSubject.invalidate();
      this.cardHolder.isCollapsed = true;
    }, error => {
      this.fuseSplashScreenService.hide();
    });
  }

  NavigateToCbCForms() {
    let command = this.GetCbCFormsCommand(this.currentFilingItem.cells.Jurisdiction.value.code);
    this.handler.executeCommand(command);
  }

  private GetCbCFormsCommand(countryCode: string) {
    var platformCommand = new PlatformCommand('CBCFormsToolLinkCommand', Api.Spreadsheet);
    platformCommand.fieldValues['CountryCode'] = countryCode;
    platformCommand.fieldValues['RedirectByPlatformLinkId'] = true;
    return platformCommand;
  }

  isNullOrUndefined(item) {
    if (item == null || item == undefined) {
      return true;
    }
    return false;
  }
}
